<template>
  <el-dialog title="开课申请" width="400px"
             :visible.sync="dialogVisible"
             :close-on-click-modal="false">
    <el-form :model="formModel" :rules="formRules" ref="formRef" label-width="110px">
      <el-alert
          title="“提交申请”后，账号将进入“审核”状态，无法操作！待平台审核通过后，方可正常使用"
          type="error"
          :closable="false">
      </el-alert><br/>
      <el-form-item label="可邀请用户数" prop="inviteUserCountMax">
        <el-input-number v-model.number="formModel.inviteUserCountMax" :min="0" :max="100" :step="10" placeholder="请输入最大邀请用户数" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleSubmit('formRef')">提交申请</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import { mapActions, mapGetters } from "vuex"
  import { updateUserBase } from '@/api/system/user'
  import { randomStringUpper } from '@/utils/randomUtil'

  const defFormModel = {
      inviteUserCountMax: 10
  }
  export default {
      props: {
          visible: {
              type: Boolean,
              default: false
          }
      },
      data() {
          return {
              dialogVisible: this.visible,
              formModel: Object.assign({},defFormModel),
              formRules: {
                  inviteUserCountMax: [
                      { required: true, message: '请填写申请用户数', trigger: 'blur' }
                  ]
              }
          }
      },
      watch: {
          visible(val, oldval) {
              if (val === oldval) {
                  return
              }
              this.dialogVisible = val
          },
          dialogVisible(val, oldval) {
              if (!val) {
                  this.$refs["formRef"].clearValidate()
              } else {
                  this.formModel = Object.assign({},defFormModel)
              }
              if (val === oldval) {
                  return
              }
              this.$emit('update:visible', val)
          }
      },
      computed: {
          ...mapGetters(['userInfo'])
      },
      methods: {
          ...mapActions(['setUserinfo']),
          handleSubmit(refName) {
              const formRef = this.$refs[refName]
              formRef.validate(valid => {
                  if (!valid) {
                      return
                  }
                  const { model } = formRef
                  const inviteObj = {
                      ...model,
                      id: this.userInfo.id,
                      inviteCode: randomStringUpper(10),
                      status: 2
                  }
                  updateUserBase(inviteObj).then(() => {
                      this.$message.success("已提交申请，等待平台审批")
                      this.dialogVisible = false
                      this.setUserinfo(Object.assign({}, this.userInfo, inviteObj))
                  })
              })
          }
      }
  }
</script>
